









export default {
  props: {
    change: {
      type: Object,
      required: true,
    },
  },

  computed: {
    metricChangeLabel() {
      return {
        icon: this.change.value >= 1 ? 'mdi-arrow-up' : 'mdi-arrow-down',
        iconColor: this.change.good ? 'green' : 'red',
        labelClass: this.change.good ? 'good' : 'bad',
      }
    },
  },
}
